import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'ea-placeholder',
    templateUrl: './ea-placeholder.component.html',
    styleUrls: ['./ea-placeholder.component.scss'],
    standalone: false
})
export class EaPlaceholderComponent implements OnInit {
  @Input() type: string = 'CARD';

  constructor() {}

  ngOnInit() {}
}
